<template>
  <img class="logo" src="./assets/logo.png" alt="魚蝦蟹 App Icon" /><br />
  <div>魚蝦蟹究竟開左幾多舖魚？幾多舖金錢？<br />用「魚蝦蟹」就幫到你！玩魚蝦蟹都可以有路捉！</div>
  <div class="preview-img-container">
    <img src="./assets/full-banner.jpg" alt="魚蝦蟹 App 預覽畫面" />
  </div>
  <AppsSection />
  <MediaCoverage />
  <DisclaimerComp />
</template>

<script>
import DisclaimerComp from './components/DisclaimerComp'
import AppsSection from './components/AppsSection'
import MediaCoverage from './components/MediaCoverage.vue';

export default {
  name: 'App',
  components: {
    AppsSection,
    DisclaimerComp,
    MediaCoverage
}
}
</script>

<style>

a {
  text-decoration: none;
  color: #2c3e50;
}

.logo {
  width: 80px;
  margin-bottom: 10px;
}

#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  padding-top: 10px;
  padding-bottom: 30px;
}

.preview-img-container {
  max-width: 80%;
  margin: 0 auto;
}

.preview-img-container img{
  width: 100%;
}

@media screen and (max-width: 720px) {
  .preview-img-container {
    max-width: 99%;
  }
}

</style>

